import { defineStore } from 'pinia'
import api from '@/utils/api'
import user from '@/data/user'

export const statsStore = defineStore('statsStore', {
  state: () => {
    return {
      stats: {
        quota: 0,
        used_space: 0
      },
      transcoderStats: {
        HD: 0,
        SD: 0
      },
      statsS3: {
        total_space: 0,
        used_space: 0
      },

      isLoadingS3Stats: false
    }
  },

  actions: {
    async loadStats () {
      try {
        const res = await api.getContainer()
        if (res.data?.[0]) {

          this.stats = { ...res.data[0] }

          user.md5_vod_key = res.data[0].md5_vod_key
          user.vod_hls = res.data[0].vod_hls
          user.container = res.data[0].name
        }
      } catch (error) {
        console.error('Failed to load stats:', error.message)
      }
    },

    async loadTranscoderStats () {
      const now = new Date()
      const start = Math.floor(new Date(now.getFullYear(), now.getMonth(), 1).getTime() / 1000)

      try {
        const res = await api.getTranscoderStats({ start: start })
        if (res.data) {
          this.transcoderStats = {
            HD: res.data.stat.HD,
            SD: res.data.stat.SD
          }
        }
      } catch (error) {
        console.error('Failed to load stats:', error.message)
      }
    },

    async loadStatsS3 () {
      try {
        const res = await api.getS3Stats()
        if (res.data) {
          this.statsS3 = res.data
        }
      } catch (error) {
        console.error('Failed to load stats:', error)
      }
    },

    adjustSpace (byte) {
      if (typeof byte !== 'number' || isNaN(byte)) {
        console.warn('adjust space: invalid byte value', byte)
        return
      }

      this.stats = {
        ...this.stats,
        used_space: Math.max(0, this.stats.used_space + byte)
      }
    },

    addMultipartToS3Stats (partSize = 0) {
      if (typeof partSize !== 'number') {
        console.warn('adjust s3 space: invalid partSize value', partSize)
        return
      }

      this.statsS3 = {
        ...this.statsS3,
        used_space: this.statsS3.used_space + partSize,
        multiparts_used_space: (this.statsS3.multiparts_used_space || 0) + partSize
      }
    }
  }
})
